import {
    Button,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import { useDispatch } from 'react-redux';
import en from '../../../../lang/en-us';
import { INACTIVE_FOLIOS } from '../../../../utils/constants';
import { RequestStatus, RequestStatusLabelMap } from '../TrackRequest/utils';
import {
    InactiveFolioPaths,
    IndividualFolioRequestType,
    IndividualFolioSummaryType,
} from '../types';
import { getAmcList } from '../../../../redux-store/actions/nct';
import { favLogos, logo } from '../../../../logo/logos';
import { RTA_CODES } from '../../../dashboard/commercial/emandate/types';

const { dashboard } = en;

export const FolioSummary = () => {
    const history = useHistory();
    const dispatch = useDispatch();
    const [amcList, setAmcList] = useState<any[]>([]);
    const {
        state: { summaryData, reqId, status, pan, registerDetails },
    } =
        useLocation<{
            summaryData: Array<IndividualFolioSummaryType>;
            reqId: string;
            status: IndividualFolioRequestType['status'];
            pan: string;
            registerDetails: { by: string; details: string };
        }>();
    

    useEffect(() => {
        const fetchAmcList = async () => {
            try {
                const { body: amcListResponse } = await getAmcList()(dispatch);
                setAmcList(amcListResponse);
            } catch (error) {
                console.error('Error fetching AMC list:', error);
            }
        };
        fetchAmcList();
    }, [dispatch]);

    const getAmcLogo = (amcName: string, svg: boolean = false) => {
        const amc = amcList.find((item) => item.amc_name.toLowerCase() === amcName.toLowerCase());
        if (svg) {
            if (amc) {
                return `/images/fav-logos/${favLogos[amc.amc_code]}.svg`;
            }
        }
        if (amc && logo[amc.amc_code]) {
            return `/images/client-logos/${logo[amc.amc_code]}.png`;
        }
        return '';
    };

    const getAmcLogoStyles = (
        amcName: string,
    ): {
        marginRight: string;
        marginLeft?: string;
        width: string;
        height: string;
        objectFit: any;
    } => {
        const amc = amcList.find((item) => item.amc_name.toLowerCase() === amcName.toLowerCase());
        /*if (amc.rta_code === RTA_CODES.CAMS) {
            if (amc.amc_code === 'B') {
                return {
                    marginRight: '12px',
                    width: '100px',
                    height: '78px',
                    objectFit: 'fill',
                };
            }
            return {
                marginRight: '12px',
                width: '100px',
                height: '38px',
                objectFit: 'fill',
            };
        }*/
       if (amc && amc.amc_code === "D") {
            return {
                marginRight: '22px',
                marginLeft: '20px',
                width: '100px',
                height: '60px',
                objectFit: 'fill',
            };
       }
        return {
            marginRight: '25px',
            width: '120px',
            height: '60px',
            objectFit: 'fill',
        };
    };

    const getAmcUrl = (amcName: string) => {
        const amc = amcList.find((item) => item.amc_name.toLowerCase() === amcName.toLowerCase());
        if (amc) {
            return amc.if_url;
        }
        return '';
    };

    return summaryData ? (
        <div className="curved-bg">
            <h2 className="heading">
                <a onClick={() => history.goBack()}>
                    <img src="/images/left-arrow-black.svg" alt="icon" />
                </a>
                {dashboard.inactiveFolios.tableHeading}
            </h2>
            <div style={{ borderRadius: '10px' }} className="card-bg">
                <div className="curved-bg-content-inner">
                    <div
                        className="transmission-download-content"
                        style={{
                            display: 'flex',
                            margin: '20px 0px',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        }}
                    >
                        <h2
                            style={{
                                color: '#000',
                                fontSize: '21px',
                                fontWeight: 'bold',
                            }}
                        >
                            Request Detail View
                        </h2>
                        <Button
                            style={{
                                fontWeight: 'bold',
                                color: '#A484DC',
                                padding: '12px 24px',
                                fontSize: '12px',
                                marginBottom: '10px',
                                cursor: 'pointer',
                                border: '1px solid #A484DC',
                                backgroundColor: 'white',
                                borderRadius: '8px',
                                textTransform: 'capitalize',
                                minWidth: '210px',
                            }}
                            onClick={() => {
                                history.replace(`/links${InactiveFolioPaths.SEARCH}`, {
                                    registerDetails,
                                    reqId,
                                    pan,
                                });
                            }}
                        >
                            Search for different name
                        </Button>
                    </div>
                    <div
                        className="request_details"
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'flex-start',
                        }}
                    >
                        <div>
                            <p
                                style={{
                                    color: '#000',
                                    marginBottom: 12,
                                    fontSize: '16px',
                                    fontWeight: 'bold',
                                }}
                            >
                                {' '}
                                Request Id{' '}
                            </p>
                            <p
                                style={{
                                    color: '#828282',
                                    marginBottom: 12,
                                    fontSize: '15px',
                                    fontWeight: '500',
                                }}
                            >
                                {' '}
                                {reqId}
                            </p>
                        </div>
                        <div>
                            <p
                                style={{
                                    borderRadius: '10px',
                                    padding: '10px',
                                    color:
                                        status === RequestStatus.Completed
                                            ? ' #489A47'
                                            : status === RequestStatus.Pending
                                            ? ' #DFBB00'
                                            : status === RequestStatus.NoDataFound
                                            ? '#DFBB00'
                                            : status === RequestStatus.Failure
                                            ? 'red'
                                            : 'unset',
                                    border:
                                        status === RequestStatus.Completed
                                            ? '1px solid #489A47'
                                            : status === RequestStatus.Pending
                                            ? '1px solid #DFBB00'
                                            : status === RequestStatus.NoDataFound
                                            ? '1px solid #DFBB00'
                                            : status === RequestStatus.Failure
                                            ? '1px solid red'
                                            : 'unset',
                                    maxWidth: '210px',
                                    margin: '0',
                                    textAlign: 'center',
                                    background:
                                        status === RequestStatus.Completed
                                            ? '#EDF8ED'
                                            : status === RequestStatus.Pending
                                            ? '#FEF8DB'
                                            : status === RequestStatus.NoDataFound
                                            ? '#FCF2E3'
                                            : 'unset',
                                    fontSize: '14px',
                                }}
                            >
                                {RequestStatusLabelMap[status]}
                            </p>
                        </div>
                    </div>
                    <div className="desktop_mode">
                        <TableContainer
                            style={{ borderRadius: '8px', border: '1px solid #eceef3' }}
                        >
                            <Table
                                className="transmission-download-table"
                                style={{ borderRadius: '8px', border: '1px solid #eceef3' }}
                            >
                                <TableHead style={{ background: '#eceef3' }}>
                                    <TableRow>
                                        <TableCell
                                            style={{
                                                borderRight: '0px',
                                                color: '#828282',
                                                fontSize: '15px',
                                                fontWeight: 'bold',
                                                textAlign: 'center',
                                            }}
                                        >
                                            {dashboard.inactiveFolios.tableColumns.amcName}
                                        </TableCell>
                                        <TableCell
                                            style={{
                                                borderRight: '0px',
                                                color: '#828282',
                                                fontSize: '15px',
                                                fontWeight: 'bold',
                                                textAlign: 'center',
                                            }}
                                        >
                                            {dashboard.inactiveFolios.tableColumns.amcDetails}
                                        </TableCell>
                                        <TableCell
                                            style={{
                                                borderRight: '0px',
                                                color: '#828282',
                                                fontSize: '15px',
                                                fontWeight: 'bold',
                                                textAlign: 'center',
                                            }}
                                        >
                                            {dashboard.inactiveFolios.tableColumns.rtaDetails}
                                        </TableCell>
                                        <TableCell
                                            style={{
                                                borderRight: '0px',
                                                color: '#828282',
                                                fontSize: '15px',
                                                fontWeight: 'bold',
                                                textAlign: 'center',
                                            }}
                                        >
                                            {dashboard.inactiveFolios.tableColumns.reqDocuments}
                                        </TableCell>
                                        <TableCell
                                            style={{
                                                borderRight: '0px',
                                                color: '#828282',
                                                fontSize: '15px',
                                                fontWeight: 'bold',
                                                textAlign: 'center',
                                            }}
                                        >
                                            {dashboard.inactiveFolios.tableColumns.invName}
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {summaryData.map((data) => {
                                        return (
                                            <TableRow style={{ borderBottom: '0px' }}>
                                                <TableCell
                                                    style={{
                                                        borderWidth: '0px 1px 0px 0px',
                                                        borderColor: '#d2d2d2',
                                                        color: '#828282',
                                                        fontSize: '13px',
                                                        fontWeight: '500',
                                                        borderRight: '1px solid #d2d2d2',
                                                        textAlign: 'center',
                                                    }}
                                                >
                                                    <div
                                                        style={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            gap: '8px',
                                                        }}
                                                    >
                                                        <a
                                                            href={getAmcUrl(data.amcName)}
                                                            target="_blank"
                                                        >
                                                            <img
                                                                src={getAmcLogo(data.amcName, true)}
                                                                alt={data.amcName}
                                                                style={getAmcLogoStyles(
                                                                    data.amcName,
                                                                )}
                                                            />
                                                        </a>
                                                        {data.amcName}
                                                    </div>
                                                </TableCell>
                                                <TableCell
                                                    style={{
                                                        borderWidth: '0px 1px 0px 0px',
                                                        borderColor: '#d2d2d2',
                                                        borderRight: '1px solid #d2d2d2',
                                                        textAlign: 'center',
                                                    }}
                                                >
                                                    <a
                                                        href={data.amcUrl}
                                                        target="_blank"
                                                        style={{
                                                            textDecoration: 'underline',
                                                            color: '#828282',
                                                            fontSize: '13px',
                                                            fontWeight: '500',
                                                        }}
                                                    >
                                                        View Details
                                                    </a>
                                                </TableCell>
                                                <TableCell
                                                    style={{
                                                        borderRight: '1px solid #d2d2d2',
                                                        textAlign: 'center',
                                                        borderWidth: '0px 1px 0px 0px',
                                                        borderColor: '#d2d2d2',
                                                    }}
                                                >
                                                    <a
                                                        href={data.rtaUrl}
                                                        target="_blank"
                                                        style={{
                                                            textDecoration: 'underline',
                                                            color: '#828282',
                                                            fontSize: '13px',
                                                            fontWeight: '500',
                                                        }}
                                                    >
                                                        View Details
                                                    </a>
                                                </TableCell>
                                                <TableCell
                                                    style={{
                                                        borderWidth: '0px 0px 0px 0px',
                                                        cursor: 'pointer',
                                                        borderRight: '1px solid #d2d2d2',
                                                        textAlign: 'center',
                                                        textDecoration: 'underline',
                                                        color: '#828282',
                                                        fontSize: '13px',
                                                        fontWeight: '500',
                                                    }}
                                                    onClick={() => {
                                                        window.open(
                                                            `${window.location.origin}/links/faq?section=${INACTIVE_FOLIOS}`,
                                                            '_blank',
                                                        );
                                                    }}
                                                >
                                                    Required Documents
                                                </TableCell>
                                                <TableCell
                                                    style={{
                                                        borderRight: '1px solid #d2d2d2',
                                                        textAlign: 'center',
                                                        borderWidth: '0px 1px 0px 0px',
                                                        borderColor: '#d2d2d2',
                                                        textDecoration: 'underline',
                                                        color: '#828282',
                                                        fontSize: '13px',
                                                        fontWeight: '500',
                                                    }}
                                                >
                                                    {data.invName}
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                    <div className="mobile_mode">
                        {summaryData.map((data) => (
                            <div
                                className="transmission-download-mobile-single"
                                style={{
                                    border: '1px solid gray',
                                    borderRadius: '5px',
                                    marginBottom: '10px',
                                }}
                            >
                                <div className="funds" style={{ fontSize: 15, padding: '15px' }}>
                                    <h4>{dashboard.inactiveFolios.tableColumns.amcName}</h4>
                                        <a href={getAmcUrl(data.amcName)} target="_blank">
                                            <img
                                                src={getAmcLogo(data.amcName, true)}
                                                alt={data.amcName}
                                                style={{
                                                    width: '60px',
                                                    height: '60px',
                                                    objectFit: 'contain',
                                                }}
                                            />
                                        </a>
                                    <p>{data.amcName}</p>
                                </div>
                                <div className="funds" style={{ fontSize: 15, padding: '15px' }}>
                                    <h4>{dashboard.inactiveFolios.tableColumns.amcDetails}</h4>
                                    <a href={data.amcUrl} target="_blank">
                                        <p> View Details</p>
                                    </a>
                                </div>
                                <div className="funds" style={{ fontSize: 15, padding: '15px' }}>
                                    <h4>{dashboard.inactiveFolios.tableColumns.rtaDetails}</h4>
                                    <a href={data.rtaUrl} target="_blank">
                                        <p> View Details</p>
                                    </a>
                                </div>
                                <div className="funds" style={{ fontSize: 15, padding: '15px' }}>
                                    <p
                                        style={{
                                            textDecoration: 'underline',
                                        }}
                                        onClick={() => {
                                            history.push('/links/faq', {
                                                section: INACTIVE_FOLIOS,
                                            });
                                        }}
                                    >
                                        {' '}
                                        Required Documents{' '}
                                    </p>
                                </div>
                                <div className="funds" style={{ fontSize: 15, padding: '15px' }}>
                                    <h4>{dashboard.inactiveFolios.tableColumns.invName}</h4>
                                    <p>{data.invName}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    ) : (
        <p> Fetching inactive folios </p>
    );
};
